import { render, staticRenderFns } from "./CashFlowConfig.vue?vue&type=template&id=28bd4964&scoped=true"
import script from "./CashFlowConfig.vue?vue&type=script&lang=js"
export * from "./CashFlowConfig.vue?vue&type=script&lang=js"
import style0 from "./CashFlowConfig.vue?vue&type=style&index=0&id=28bd4964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd4964",
  null
  
)

export default component.exports